<template>
  <vl-pager mod-align="right" mod-align-l="right" mod-align-m="right" mod-align-xs="right">
    <vl-pager-bounds
      :from="firstRowIndex.toString()"
      :to="lastRowIndex.toString()"
      :total="totalRows.toString()"
      page-label="Pagina"
      prefix="van"
    />
    <template v-if="totalRows > pageSize">
      <vl-pager-item v-if="canPreviousPage" a11y-label="vorige" label="Vorige" type="previous" @click="previousPage" />
      <li v-else class="vl-pager__element vl-pager__element--disabled">
        <span> Vorige </span>
      </li>
    </template>
    <vl-pager-page
      v-for="page in pageItems"
      :key="page"
      :mod-active="page === (currentPageIndex + 1).toString()"
      :number="page"
      a11y-label="page"
      @click="clickablePage(page) && goPage(parseInt(page))"
    />
    <template v-if="totalRows > pageSize">
      <vl-pager-item v-if="canNextPage" a11y-label="volgende" label="Volgende" type="next" @click="nextPage" />
      <li v-else class="vl-pager__element vl-pager__element--disabled">
        <span> Volgende </span>
      </li>
    </template>
  </vl-pager>
</template>
<script lang="ts" src="./vl-data-table-extended-pager.ts" />
